import {
  config
} from '../_config';
import {
  authHeader,
  handleResponse
} from '../_helpers';

export const userService = {
  login,
  logout,
  register,
  update,
  newPhone,
  updatePhone,
  deletePhone,
  refreshUserData,   
  getCountries,
  actChangeUserMail,
  actUserValidateMailChange
}

function login(username, password, remember_me) {

  const formData = new FormData()

  formData.append('email', username)
  formData.append('password', password)
  formData.append('remember_me', remember_me)
  //TODO: 03/08/2019 Agregar funcionalidad para el rememberMe
  //formData.append('client_secret', config.oauth.secret)
  //formData.append('client_id', config.oauth.clientId)
  //formData.append('grant_type', config.oauth.grantType)

  // eslint-disable-next-line no-console  
  //console.log(formData.values());



  const requestOptions = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData

  };
  return fetch(`${config.apiUrl}/auth/login`, requestOptions)
    .then(handleResponse)
    .then(response => {
      // login successful if there's a jwt token in the response
      if (response.user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        // console.log("llego a la respuesta del user",  JSON.stringify(response.user) );
        localStorage.setItem('user', JSON.stringify(response.user));
      }
      return response.user;

    });
}

function refreshUserData(user_id) {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  
  return fetch(`${config.apiUrl}/users/${user_id}`, requestOptions)
  .then(handleResponse)
    .then(response => {     
      return response;
    }).catch(error => {
      console.log(error)
    })

}

function logout() {

  // 01/08/2019 : Funcionalidad OK - agregada funcionalidad en la api

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch(`${config.apiUrl}/auth/logout`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.removeItem('user');
      localStorage.removeItem('countries');
      return response;
    })


}

function register(user) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/register`, requestOptions).then(handleResponse);
}


function update(user) {
  // TODO: 05/08/2019 solamente actualiza los datos de la tabla user en la API
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/users/${user.id}`, requestOptions)
    .then(handleResponse);
}
/**
 * alta de un nuevo telefono
 * @param {object} phone 
 */

function newPhone(phone) {

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(phone)
  };

  return fetch(`${config.apiUrl}/phones/create`, requestOptions).then(handleResponse);

}

function updatePhone(phone) {

  const requestOptions = {
    method: 'PUT',
    headers: {
        ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(phone)
  };

  return fetch(`${config.apiUrl}/phones/${phone.id}`, requestOptions).then(handleResponse);

}

function deletePhone(objPhone) {

  const requestOptions = {      
    method: 'DELETE',
    headers: {
        ...authHeader(),
      'Content-Type': 'application/json'
    }
  };

  return fetch(`${config.apiUrl}/phones/${objPhone.id}`, requestOptions).then(handleResponse);

}

/**
 *  Dogs
 */
//los recogemos del userData
/*  function getUserDogs() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/countries`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('countries', JSON.stringify(response));

      return response;

    })

 } */





/**
 * functiones varias
 */
function getCountries() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/countries`, requestOptions)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('countries', JSON.stringify(response));

      return response;

    })
}

function actChangeUserMail(data) {

  const requestOptions = {
    method: 'POST',
    headers: {
        ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };

  return fetch(`${config.apiUrl}/userMailChange`, requestOptions).then(handleResponse);

}

function actUserValidateMailChange(data) {
    console.log(data)
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      };
    
      return fetch(`${config.apiUrl}/userValidateMailChange`, requestOptions).then(handleResponse);
    
}